import { type DateLike, toDate } from "./jalali";

const HOUR_MS = 3_600_000;
const DAY_MS = 86_400_000;

/**
 * Human countdown sentence, e.g. «قابل برداشت در 9 روز دیگر».
 * Digits stay ASCII; the font draws them Persian.
 */
export function countdownText(target: DateLike, now: DateLike = new Date(), prefix = "قابل برداشت"): string {
    const diff = toDate(target).getTime() - toDate(now).getTime();
    if (diff <= 0) return `${prefix} است`;
    if (diff < HOUR_MS) return `${prefix} تا کمتر از یک ساعت دیگر`;
    if (diff < DAY_MS) return `${prefix} تا ${Math.ceil(diff / HOUR_MS)} ساعت دیگر`;
    return `${prefix} در ${Math.ceil(diff / DAY_MS)} روز دیگر`;
}
